import { inject, Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';

const FILTER_WRITE = 'query-params-filter-write';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
    private readonly router = inject(Router);

    current(): Params {
        return this.router.routerState.snapshot.root.queryParams;
    }

    // Params are merged, so a caller must pass every key it owns, using `null` for a default value to remove it.
    write(params: Params): void {
        const navigation = this.router.getCurrentNavigation();
        if (navigation && navigation.extras.info !== FILTER_WRITE) {
            return;
        }
        // Best-effort: a rejected navigation (e.g. a guard threw) must not surface as an unhandled rejection.
        this.router
            .navigate([], { queryParams: params, queryParamsHandling: 'merge', replaceUrl: true, info: FILTER_WRITE })
            .catch(() => undefined);
    }
}
